// On hover menu open
jQuery("#HeaderMenu-shop,#MegaMenu-Content-1").hover(
  function () {
    jQuery("#Details-HeaderMenu-1").attr("open", "open");
    jQuery(this).attr("aria-expanded", "true");
  },
  function () {
    jQuery("#Details-HeaderMenu-1").removeAttr("open");
    jQuery(this).attr("aria-expanded", "false");
  }
);

// Tabs
jQuery(document).ready(function () {
  jQuery("#tabs").tabs();
});

jQuery(document).ready(function () {
  jQuery(".collection-navigation-type").on("click", function () {
    jQuery(this).toggleClass("active");
    jQuery(".collection-navigation-menu").toggleClass("active");
  });
});

jQuery(document).ready(function () {
  jQuery("#HeaderMenu-about-us,#HeaderMenu-1-for-the-future").attr(
    "target",
    "_blank"
  );
});

document.addEventListener("DOMContentLoaded", async function () {
  var disclosure_input = document.querySelectorAll(".disclosure--input");
  disclosure_input.forEach((disclosure) => {
    disclosure.addEventListener("change", async function (e) {
      window.BOLD = window.BOLD || {};
      window.BOLD.BsubWidget = new BsubWidget();
      window.BOLD.BsubWidget.init();
    });
  });
});

jQuery(document).on("click", ".disclosure--option", function () {
  var selectedvariantvalu = jQuery(this).attr("data-value");
  if (
    selectedvariantvalu == "2.4 OZ BOTTLE" ||
    selectedvariantvalu == "16.9 OZ BOTTLE + PUMP"
  ) {
    jQuery(document)
      .find('input[name="bsub-selling-plan-group"][value="once"]')
      .trigger("click");
    jQuery(document).find(".bsub-widget").hide();
  } else {
    jQuery(document)
      .find('input[name="bsub-selling-plan-group"][value="once"]')
      .trigger("click");
    jQuery(document).find(".bsub-widget").show();
  }
});

var acc = document.getElementsByClassName("accordion");
var i;
for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
      panel.style.marginBottom = "0px";
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
      panel.style.marginBottom = "15px";
    }
  });
}

// // This script waits for the entire HTML document to be loaded before executing.
// document.addEventListener("DOMContentLoaded", function () {
//   // Select the mobile navigation menu element.
//   // This is where the image will be inserted.
//   const mobileNavMenu = document.querySelector(".mobile-nav--menu");

//   // Check if the mobile navigation menu exists on the page.
//   if (mobileNavMenu) {
//     // Create a new div element to act as a container for the image.
//     const imageContainer = document.createElement("div");
//     // Add a class to the container for potential styling (e.g., margin, padding).
//     imageContainer.classList.add("mobile-menu-image");

//     // Create a new anchor (link) element.
//     const link = document.createElement("a");
//     // Set the href attribute for the link. You can change this to your desired URL.
//     link.href = "#"; // Example: link.href = '/your-image-destination-page';
//     // Add a descriptive title for accessibility.
//     link.title = "Learn more about Alpine Provisions";

//     // Create a new img element.
//     const img = document.createElement("img");
//     // Set the source (URL) of the image.
//     // This URL is the image generated in the previous turn.
//     img.src = "https://cdn.shopify.com/s/files/1/0251/4088/7607/files/Gemini_Generated_Image_9vfybk9vfybk9vfy.png?v=1753711567";
//     // Set the alt text for accessibility, describing the image content.
//     img.alt = "Alpine Provisions Information";
//     // Set CSS properties to make the image responsive within its container.
//     img.style.maxWidth = "100%"; // Ensures the image doesn't overflow its parent.
//     img.style.height = "auto"; // Maintains the image's aspect ratio.

//     // Append the image element to the link element.
//     link.appendChild(img);

//     // Append the link element (which now contains the image) to the image container.
//     imageContainer.appendChild(link);

//     // Insert the newly created image container at the end of the mobile menu content.
//     // The `appendChild()` method inserts the specified content as the last child of the element.
//     mobileNavMenu.appendChild(imageContainer);
//   }
// });


document.addEventListener('DOMContentLoaded', function () {
  var stickySection = document.querySelector('body'); // change selector

  if (!stickySection) return;

  window.addEventListener('scroll', function () {
    if (window.scrollY > 0) {
      stickySection.classList.add('is-sticky');
    } else {
      stickySection.classList.remove('is-sticky');
    }
  });
});